import { jsx } from 'panel';
import { Directions, DropMenuEl } from 'common/components/drop-menu';
import { CreateAnnotationFormEl } from './create-annotation-form';
import { ViewAnnotationsListEl } from './view-annotations-list'; // until insights uses mp-line-chart any changes in here may
// need to be in iron/apps/insights/src/insights-app/insights-result/chart-display/line-chart/index.jade

export function AnnotationsMixin() {
  const {
    annotations
  } = this.state;
  const POPOVER_MAX_WIDTH = 350;
  return annotations.activeAnnotationButton ? jsx(DropMenuEl, {
    sel: '.line-chart-annotation-popup',
    attrs: {
      open: !annotations.activeAnnotationPopupClosing,
      direction: Directions.Up
    },
    on: {
      change: this.helpers.annotations.popupChange
    },
    style: {
      left: "".concat(Math.max(annotations.activeAnnotationButton.x, POPOVER_MAX_WIDTH / 2), "px"),
      bottom: "".concat(annotations.activeAnnotationButton.topOfButtonToBottomOfChart, "px"),
      transform: "translateX(calc(-50% + ".concat(annotations.activeAnnotationButton.width / 2, "px))"),
      'max-width': "".concat(POPOVER_MAX_WIDTH)
    },
    key: "annotation-popup-".concat(annotations.activeAnnotationButton.timestampMs)
  }, annotations.creatingAnnotation ? jsx(CreateAnnotationFormEl, {
    key: annotations.createAnnotationDate,
    attrs: {
      elref: "createAnnotationForm",
      'utc-offset': this.attr("utc-offset"),
      date: annotations.createAnnotationDate
    },
    on: {
      annotationCreated: this.helpers.annotations.add,
      closeAnnotationPopup: this.helpers.annotations.close
    }
  }) : annotations.viewingAnnotations ? jsx(ViewAnnotationsListEl, {
    attrs: {
      elref: "viewAnnotationsList",
      'active-annotation': annotations.activeAnnotationButton,
      'active-annotation-group': annotations.visibleAnnotations.get(annotations.activeAnnotationButton.timestampMs),
      'annotation-description-draft': annotations.annotationDescriptionDraft,
      'can-write-annotations': this.attr("show-annotations"),
      'editing-annotation': annotations.editingAnnotation,
      'deleting-annotation': annotations.deletingAnnotation,
      'time-unit': this.attr("time-unit")
    },
    on: {
      closeAnnotationPopup: this.helpers.annotations.close,
      showCreateAnnotation: this.helpers.annotations.showCreate,
      editAnnotation: this.helpers.annotations.edit,
      deleteAnnotation: this.helpers.annotations.delete,
      updateAnnotationDescriptionDraft: this.helpers.annotations.updateDescriptionDraft,
      saveAnnotation: this.helpers.annotations.save,
      editCanceled: this.helpers.annotations.editCanceled,
      deleteConfirmed: this.helpers.annotations.deleteConfirmed,
      deleteCanceled: this.helpers.annotations.deleteCanceled
    }
  }) : null) : annotations.activeAnnotationPreview ? jsx(DropMenuEl, {
    sel: '.line-chart-annotation-popup',
    attrs: {
      open: true,
      direction: Directions.Up
    },
    style: {
      left: "".concat(Math.max(annotations.activeAnnotationPreview.x, POPOVER_MAX_WIDTH / 2), "px"),
      bottom: "".concat(annotations.activeAnnotationPreview.topOfButtonToBottomOfChart, "px"),
      transform: "translateX(calc(-50% + ".concat(annotations.activeAnnotationPreview.width / 2, "px))"),
      'max-width': "".concat(POPOVER_MAX_WIDTH)
    },
    key: "annotation-preview-".concat(annotations.activeAnnotationPreview.timestampMs)
  }, jsx(ViewAnnotationsListEl, {
    attrs: {
      elref: "viewAnnotationsList",
      'active-annotation': annotations.activeAnnotationPreview,
      'active-annotation-group': annotations.visibleAnnotations.get(annotations.activeAnnotationPreview.timestampMs),
      'time-unit': this.attr("time-unit"),
      type: "preview"
    }
  })) : null;
}